import {importData} from '../../Queries';
import Table from '../../app-components/table/Table';
import {ImportCard} from './ImportCard';

export default Table({
  uri: importData,
  reloadEvent: 'reloadimport',
  ...ImportCard,
});
